module.exports = __webpack_public_path__ + "img/sendDark.d6652f24.svg";